import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3"
}
const _hoisted_2 = {
  key: 1,
  class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3"
}
const _hoisted_3 = { class: "flex flex-column gap-3 mt-3 mb-3" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "block mb-1 text-color text-base"
}, "Response Category", -1)
const _hoisted_7 = { class: "p-input-icon-left w-full" }
const _hoisted_8 = { class: "w-half flex align-items-end justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.editMode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Specify a different set of one or more words that you would like to sue to categorize your campaign responses."))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, "Specify one or more words that you would like to use to categorize your campaign responses. For instance, if you want a \"No\" category, you might add a comma delimited \"No, Nah, Never\".")),
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_InputText, {
              name: "name",
              type: "text",
              modelValue: _ctx.categoryName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryName) = $event)),
              class: "w-full",
              id: "name",
              placeholder: "John Doe",
              required: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            onClick: _cache[1] || (_cache[1] = $event => _ctx.addCategory(_ctx.categoryInfo)),
            icon: "pi pi-plus",
            disabled: !_ctx.categoryInfo.categoryLabels.value,
            text: "",
            rounded: ""
          }, null, 8, ["disabled"])
        ])
      ])
    ])
  ], 64))
}